/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { auth } from "@/services";

(function (angular) {
  angular.module("app").controller("myFeedController", myFeedController);

  myFeedController.$inject = [
    "thisSiteSettings",
    "FeedApi",
    "memberPayload",
    "PollVotesApi",
    "Helpers",
    "$scope",
    "UsersApi",
    "$rootScope",
    "thisUser",
    "GroupsApi",
    "alerts",
  ];

  function myFeedController(
    thisSiteSettings,
    FeedApi,
    memberPayload,
    PollVotesApi,
    Helpers,
    $scope,
    UsersApi,
    $rootScope,
    thisUser,
    GroupsApi,
    alerts,
  ) {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const vm = this;
    vm.limit = 12;
    const nowISO = window.moment().format(Helpers.isoFormat);
    vm.member = new UsersApi(memberPayload);

    vm.filters = {
      filter_by: null,
      order_by: "created_at",
      order: "desc",
      page: "1",
      per_page: "20",
      user_id: vm.member.id,
    };

    vm.getFilterTitles = getFilterTitles;

    // Get true or false value from site's setting to see if feed is enabled
    vm.feedEnabled = [];

    vm.permissionChecks = {
      events: auth.hasPermission("events.view"),
      polls: auth.hasPermission("polls.view"),
      packages: auth.hasPermission("packages.view"),
      news: auth.hasPermission("news.view:directory"),
      resources: auth.hasPermission("resources.view"),
      promotions: auth.hasPermission("promotions.view"),
      users: auth.hasPermission("users.view:directory"),
    };

    vm.orderFilters = {
      all: {
        label: "Everything",
        filter_by: null,
        order_by: "created_at",
        order: "desc",
        page: "1",
        per_page: "20",
        user_id: vm.member.id,
      },
      events: {
        label: "Events",
        filter_by: "events",
        order_by: "created_at",
        order: "desc",
        page: "1",
        per_page: "20",
        user_id: vm.member.id,
      },
      polls: {
        label: "Polls",
        filter_by: "polls",
        order_by: "created_at",
        order: "desc",
        page: "1",
        per_page: "20",
        user_id: vm.member.id,
      },
      packages: {
        label: "Packages",
        filter_by: "packages",
        order_by: "created_at",
        order: "desc",
        page: "1",
        per_page: "20",
        user_id: vm.member.id,
      },
      news: {
        label: "News",
        filter_by: "news",
        order_by: "created_at",
        order: "desc",
        page: "1",
        per_page: "20",
        user_id: vm.member.id,
      },
      resources: {
        label: "Resources",
        filter_by: "resources",
        order_by: "created_at",
        order: "desc",
        page: "1",
        per_page: "20",
        user_id: vm.member.id,
      },
      promotions: {
        label: "Promotions",
        filter_by: "promotions",
        order_by: "created_at",
        order: "desc",
        page: "1",
        per_page: "20",
        user_id: vm.member.id,
      },
    };

    if (thisUser) {
      // Check user permissions and filter orderFilters accordingly
      Object.keys(vm.orderFilters).forEach((key) => {
        // If there is a corresponding permission check for the key and it's false, remove it
        if (key !== "all" && !vm.permissionChecks[key]) {
          delete vm.orderFilters[key];
        }
      });
    }

    vm.selectedOrderFilter = vm.orderFilters.all;

    //** date order */
    vm.orderdateFilters = {
      descending: {
        label: "Last activity",
        order_by: "created_at",
        order: "desc",
        page: "1",
        per_page: "20",
        user_id: vm.member.id,
      },
      ascending: {
        label: "First activity",
        order_by: "created_at",
        order: "asc",
        page: "1",
        per_page: "20",
        user_id: vm.member.id,
      },
    };
    vm.selectedOrderdateFilter = vm.orderdateFilters.descending;
    //**date order finishes here */
    vm.getFeed = getFeed;
    vm.orderFeed = orderFeed;
    $scope.requestResource = requestResource;
    $scope.usersGroups = thisUser.groups.map(function (group) {
      return group.id;
    });

    function getFilterTitles() {
      fetch("/api/settings/titles")
        .then((response) => response.json())
        .then((data) => {
          for (const [key, value] of Object.entries(data.data)) {
            vm.orderFilters[key].label = value;
          }
        })
        .catch((error) => {
          console.error("Error fetching filter titles:", error);
        });
    }

    /**
     * Retrieves events from the API
     * @return {void}
     */
    function getFeed() {
      vm.isLoading = true;

      FeedApi.get(
        vm.filters,
        (response) => {
          vm.feedItems = response.data;
          getFilterTitles();

          vm.isLoading = false;
        },
        (error) => {
          vm.isLoading = false;
        },
      );
    }
    /**
     * Updates filters and refreshes the events.
     * Called by the order events select control.
     *
     * @return {void}
     */
    function orderFeed() {
      angular.merge(
        vm.filters,
        vm.selectedOrderFilter,
        vm.orderdateFilter,
        vm.selectedOrderdateFilter,
      );
      vm.filters.label = null;
      getFeed();
    }
    $scope.loadMore = function () {
      var increamented = vm.limit + 3;
      vm.limit =
        increamented > vm.feedItems.length ? vm.feedItems.length : increamented;
    };

    // Only get feed items if feed is enabled
    if (vm.feedEnabled) {
      // Handle the api call response - saves the response to feedItems variable
      const handleFeedResponse = (response) => {
        vm.feedItems = response.data;
        checkRequested();
      };

      /**
       *  Run the api get call
       *  Can send the below parameters when impelementing filters
       */
      FeedApi.get(
        {
          filter_by: null,
          order_by: "created_at",
          order: "desc",
          page: "1",
          per_page: "20",
          user_id: vm.member.id,
        },
        handleFeedResponse,
      );
    }

    // Poll items script
    vm.vote = vote;

    /**
     * Sends the user's chosen option to the API, and shows the results
     * @param {object} feedItem - The poll voted on
     * @param {object} option - User's chosen option
     * @return {void}
     */
    function vote(feedItem, option) {
      feedItem.selectedOption = option;

      // if selected option not set.
      if (!feedItem.selectedOption.id) {
        return;
      }

      var data = {
        poll_option_id: feedItem.selectedOption.id,
      };

      PollVotesApi.vote(data, function (response) {
        feedItem.options = response.data.poll_options;
        feedItem.current_users_vote = feedItem.selectedOption.id;
      });
    }

    /**
     * Sends the connection request to the API
     * @return {void}
     */
    function requestResource(groupId, feedItem) {
      $scope.isLoadingMessage = "Sending request...";
      $scope.isLoading = true;

      GroupsApi.GroupUserRequest(
        { group_id: groupId },
        {
          user_id: thisUser.id,
        },
        function handleRequesttResponse(response) {
          $scope.isLoading = false;

          feedItem.userRequested = true;

          alerts.emit({
            theme: "success",
            title: "Request Sent",
            messages: [],
          });
        },
        function handleRequesttError() {
          $scope.isLoading = false;
          $scope.forceClose = true;
        },
      );
    }

    function checkRequested() {
      vm.feedItems.forEach(checkItem);

      function checkItem(item, index, a) {
        a[index].userRequested = false;

        if (item.group) {
          if (
            item.groupRequests.filter((o) => o.user_id === thisUser.id).length >
            0
          ) {
            a[index].userRequested = true;
          }
        }
      }
    }

    function bootstrap() {
      vm.getFeed();

      vm.isLoading = false;
    }

    bootstrap();
  }
})(angular);
